import { categories } from './homeData';

export const allVideos = [
  {
    id: 1, title: '星际穿越', category: 'movie', thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20exploration%20movie%20scene%20with%20astronaut%20floating%20near%20a%20massive%20black%20hole%20wormhole%20in%20deep%20space%20cinematic%20lighting%20dramatic%20composition%20film%20poster%20style&width=640&height=360&seq=cat-video-1&orientation=landscape', rating: 9.4, views: '1280万', isVip: false, duration: '169分钟', date: '2026-07-15',
  },
  {
    id: 2, title: '舌尖上的中国·第四季', category: 'documentary', thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20traditional%20cuisine%20cooking%20in%20rustic%20kitchen%20steaming%20hot%20dishes%20warm%20ambient%20lighting%20rich%20colors%20cinematic%20food%20photography&width=640&height=360&seq=cat-video-2&orientation=landscape', rating: 9.6, views: '3500万', isVip: true, duration: '50分钟/集', date: '2026-06-20',
  },
  {
    id: 3, title: '王者之路', category: 'variety', thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20variety%20show%20stage%20with%20colorful%20lighting%20and%20energetic%20performers%20dancing%20on%20a%20grand%20stage%20with%20live%20audience%20dynamic%20atmosphere%20entertainment%20show&width=640&height=360&seq=cat-video-3&orientation=landscape', rating: 8.9, views: '2100万', isVip: false, duration: '90分钟/期', date: '2026-07-08',
  },
  {
    id: 4, title: '灵笼·终章', category: 'anime', thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20animation%20sci-fi%20scene%20with%20post%20apocalyptic%20cityscape%20floating%20in%20the%20sky%20mechanical%20structures%20dramatic%20orange%20and%20teal%20color%20grading%20epic%20anime%20art%20style&width=640&height=360&seq=cat-video-4&orientation=landscape', rating: 9.2, views: '5600万', isVip: true, duration: '25分钟/集', date: '2026-07-01',
  },
  {
    id: 5, title: '长津湖之水门桥', category: 'movie', thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20historical%20war%20film%20scene%20with%20soldiers%20in%20winter%20battlefield%20snow%20covered%20mountains%20dramatic%20cinematic%20lighting%20heroic%20composition%20film%20poster%20style%20intense%20atmosphere&width=640&height=360&seq=cat-video-5&orientation=landscape', rating: 9.3, views: '4200万', isVip: false, duration: '149分钟', date: '2026-06-28',
  },
  {
    id: 6, title: '流浪地球3', category: 'movie', thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20science%20fiction%20film%20scene%20with%20Earth%20moving%20through%20space%20powered%20by%20massive%20engines%20blue%20glowing%20thrusters%20surrounded%20by%20Jupiter%20cinematic%20epic%20scale%20dramatic%20lighting&width=640&height=360&seq=cat-video-6&orientation=landscape', rating: 9.0, views: '6800万', isVip: true, duration: '173分钟', date: '2026-07-20',
  },
  {
    id: 7, title: '繁花', category: 'tv', thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20television%20series%20scene%20set%20in%201990s%20Shanghai%20with%20elegant%20characters%20in%20vintage%20clothing%20walking%20on%20a%20busy%20neon%20lit%20street%20nostalgic%20atmosphere%20cinematic%20lighting&width=640&height=360&seq=cat-video-7&orientation=landscape', rating: 9.1, views: '8900万', isVip: true, duration: '45分钟/集', date: '2026-05-15',
  },
  {
    id: 8, title: 'NBA季后赛精选', category: 'sports', thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20NBA%20basketball%20playoff%20game%20scene%20with%20player%20dunking%20the%20ball%20in%20a%20packed%20arena%20dramatic%20sports%20photography%20intense%20action%20dynamic%20lighting%20professional%20basketball&width=640&height=360&seq=cat-video-8&orientation=landscape', rating: 9.3, views: '3200万', isVip: false, duration: '120分钟', date: '2026-07-18',
  },
  {
    id: 9, title: '蓝色星球III', category: 'documentary', thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20nature%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20diverse%20marine%20life%20swimming%20in%20crystal%20clear%20deep%20blue%20ocean%20cinematic%20underwater%20photography%20beautiful%20natural%20light&width=640&height=360&seq=cat-video-9&orientation=landscape', rating: 9.7, views: '2100万', isVip: true, duration: '60分钟/集', date: '2026-07-05',
  },
  {
    id: 10, title: '熊出没·奇幻空间', category: 'kids', thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20animated%20children%20film%20scene%20with%20two%20friendly%20bears%20exploring%20a%20magical%20forest%20full%20of%20glowing%20plants%20and%20butterflies%20bright%20cheerful%20animation%20style%20for%20kids&width=640&height=360&seq=cat-video-10&orientation=landscape', rating: 8.8, views: '5600万', isVip: false, duration: '105分钟', date: '2026-06-10',
  },
  {
    id: 11, title: '中国好声音2026', category: 'music', thumbnail: 'https://readdy.ai/api/search-image?query=Music%20talent%20show%20stage%20with%20singer%20performing%20under%20colorful%20spotlights%20on%20a%20grand%20stage%20with%20turning%20red%20chairs%20and%20excited%20audience%20dynamic%20concert%20atmosphere%20entertainment&width=640&height=360&seq=cat-video-11&orientation=landscape', rating: 8.5, views: '4100万', isVip: false, duration: '100分钟/期', date: '2026-07-12',
  },
  {
    id: 12, title: '长安三万里', category: 'anime', thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animated%20historical%20film%20scene%20set%20in%20ancient%20Tang%20Dynasty%20Chang%20an%20city%20with%20traditional%20architecture%20lanterns%20and%20poets%20in%20flowing%20robes%20elegant%20artistic%20animation%20style&width=640&height=360&seq=cat-video-12&orientation=landscape', rating: 9.0, views: '7200万', isVip: false, duration: '168分钟', date: '2026-07-22',
  },
];

export function getVideosByCategory(categorySlug: string) {
  if (categorySlug === 'all') return allVideos;
  const catMap: Record<string, string> = {
    movie: 'movie', tv: 'tv', variety: 'variety', anime: 'anime',
    documentary: 'documentary', kids: 'kids', sports: 'sports', music: 'music',
  };
  const mapped = catMap[categorySlug];
  if (!mapped) return allVideos;
  return allVideos.filter((v) => v.category === mapped);
}

export const articles = [
  {
    id: 1,
    title: '星际穿越：穿越时空的科幻史诗',
    category: 'movie',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20film%20analysis%20with%20astronaut%20near%20wormhole%20in%20deep%20space%20cinematic%20lighting%20dramatic%20composition%20movie%20review%20banner%20style%20professional%20film%20critique&width=1200&height=600&seq=article-1&orientation=landscape',
    author: '影评人李明',
    date: '2026-07-15',
    views: '1280万',
    rating: 9.4,
    duration: '169分钟',
    isVip: false,
    summary: '克里斯托弗·诺兰执导的《星际穿越》是一部将硬核科学与人性情感完美融合的科幻巨制。影片通过一组宇航员穿越虫洞寻找人类新家园的故事，展现了时间的相对性、父爱的永恒以及人类面对未知时的勇气。',
    content: `
      <h2>影片概述</h2>
      <p>《星际穿越》（Interstellar）是克里斯托弗·诺兰执导的一部科幻电影，于2014年上映。影片由马修·麦康纳、安妮·海瑟薇、杰西卡·查斯坦等主演。故事设定在不远的未来，地球正面临严重的环境危机，农作物相继灭绝，人类面临生存困境。</p>

      <h2>剧情简介</h2>
      <p>前NASA飞行员库珀被选中参与一项秘密的太空探索任务，与其他科学家一起穿越土星附近出现的虫洞，前往另一个星系寻找适合人类居住的新星球。在这次跨越时空的旅程中，库珀不仅要面对未知宇宙的危险，还要承受与女儿墨菲分离的痛苦。</p>

      <h2>科学与情感的交织</h2>
      <p>诺兰在影片中大胆探讨了相对论中的时间膨胀效应。当库珀和队友在靠近黑洞的米勒星球上度过短短几小时时，地球上的时间已经过去了23年。这种时间差带来的情感冲击令人震撼——库珀看着儿女们多年来的视频信息，从孩童到成人，而自己却未曾陪伴左右。</p>

      <h2>视觉奇观</h2>
      <p>影片中的黑洞"卡冈图雅"是基于物理学家基普·索恩提供的数学模型渲染而成，这是影史上对黑洞最科学的视觉呈现。虫洞、五维空间等概念在银幕上的呈现也极具想象力，为观众带来前所未有的视觉震撼。</p>

      <h2>主题深度</h2>
      <p>《星际穿越》的核心主题是爱与时间的关系。影片通过库珀与墨菲的父女情，传达出"爱是一种可以穿越维度的力量"的理念。汉斯·季默的配乐更是将这种情感推向了极致，管风琴的宏大音色完美呼应了宇宙的浩瀚与人类情感的深邃。</p>

      <h2>结语</h2>
      <p>《星际穿越》不仅是一部视觉盛宴，更是一部引人深思的哲学作品。它让我们思考：在浩瀚宇宙面前，人类如此渺小，但爱与勇气却能让我们跨越时空的界限。这正是科幻电影的最高境界——以科学的严谨性为基础，讲述关于人性的永恒故事。</p>
    `,
    tags: ['科幻', '诺兰', '太空', '经典'],
    related: [2, 3, 6],
  },
  {
    id: 2,
    title: '舌尖上的中国·第四季：寻味华夏大地',
    category: 'documentary',
    categoryName: '纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20review%20with%20beautiful%20traditional%20cuisine%20display%20on%20wooden%20table%20in%20rustic%20kitchen%20warm%20lighting%20rich%20colors%20professional%20food%20photography%20editorial%20style&width=1200&height=600&seq=article-2&orientation=landscape',
    author: '美食评论员王芳',
    date: '2026-06-20',
    views: '3500万',
    rating: 9.6,
    duration: '50分钟/集',
    isVip: true,
    summary: '《舌尖上的中国》第四季继续以美食为窗口，深入中国各地探寻人与食物之间的情感纽带，展现中华饮食文化的博大精深与时代变迁。',
    content: `
      <h2>系列回顾</h2>
      <p>《舌尖上的中国》自2012年首播以来，一直是中国最具影响力的美食纪录片系列。第四季在延续前作精髓的同时，更加注重对当代饮食文化变迁的观察与记录。</p>
      <h2>本季亮点</h2>
      <p>第四季的拍摄范围更加广泛，从东北雪原到海南椰林，从西北戈壁到江南水乡，摄制组走遍中国34个省级行政区，记录了上百种地方特色美食的制作过程。</p>
      <h2>美食背后的人文故事</h2>
      <p>每一道美食背后都有一群默默坚守的人。纪录片不仅展示食物的色香味，更深入挖掘了食材种植者、传统手艺人和创新厨师的故事，让观众感受到食物承载的情感与文化。</p>
      <h2>时代印记</h2>
      <p>本季特别关注了互联网时代对传统饮食文化的影响——外卖经济、网红美食、直播带货等现象被首次纳入纪录片的叙事框架，展现了传统与现代的碰撞与融合。</p>
    `,
    tags: ['美食', '纪录片', '文化', '传统'],
    related: [1, 9, 5],
  },
  {
    id: 3,
    title: '王者之路：音乐竞技的巅峰对决',
    category: 'variety',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20stage%20with%20spotlight%20on%20a%20singer%20performing%20passionately%20with%20band%20colorful%20stage%20lighting%20grand%20atmosphere%20entertainment%20show%20banner%20style&width=1200&height=600&seq=article-3&orientation=landscape',
    author: '娱乐观察员陈静',
    date: '2026-07-08',
    views: '2100万',
    rating: 8.9,
    duration: '90分钟/期',
    isVip: false,
    summary: '《王者之路》以创新的赛制和顶级的舞台制作，重新定义了音乐竞技综艺的标准，成为2026年最受关注的综艺节目之一。',
    content: `
      <h2>节目介绍</h2>
      <p>《王者之路》是一档大型音乐竞技真人秀节目，汇聚了华语乐坛的实力唱将和新生代歌手，通过多轮淘汰赛制角逐"年度歌王"的桂冠。</p>
      <h2>赛制创新</h2>
      <p>本季节目引入了全新的"盲选对决"和"听众评审团"机制，参赛者在不知道对手身份的情况下进行PK，增加了节目的悬念和观赏性。</p>
      <h2>舞台制作</h2>
      <p>节目组投入巨资打造了360度沉浸式舞台，采用最新的AR增强现实技术和杜比全景声系统，为观众带来影院级的视听享受。</p>
    `,
    tags: ['综艺', '音乐', '竞技', '舞台'],
    related: [1, 11, 4],
  },
  {
    id: 4,
    title: '灵笼·终章：国产动画的新高度',
    category: 'anime',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20animation%20art%20review%20with%20post%20apocalyptic%20floating%20city%20mechanical%20structures%20dramatic%20orange%20and%20teal%20colors%20epic%20anime%20banner%20style%20professional%20animation%20review&width=1200&height=600&seq=article-4&orientation=landscape',
    author: '动漫评论员张伟',
    date: '2026-07-01',
    views: '5600万',
    rating: 9.2,
    duration: '25分钟/集',
    isVip: true,
    summary: '《灵笼》作为国产原创科幻动画的标杆之作，终章以震撼的视觉效果和深刻的哲学思考，为这个末世故事画上了圆满的句号。',
    content: `
      <h2>作品背景</h2>
      <p>《灵笼》是由艺画开天制作的原创科幻动画，讲述了末日世界中人类在灯塔城艰难求生的故事。作品以宏大的世界观构建和精致的3D制作，开创了国产动画的新纪元。</p>
      <h2>终章解析</h2>
      <p>终章揭示了玛娜生态的终极秘密，主角马克在经历了无数磨难后，终于找到了人类与噬极兽共存的可能。这一设定打破了传统末日题材的二元对立思维，提出了更具深度的生存哲学命题。</p>
      <h2>制作水准</h2>
      <p>终章的制作水平达到了国产动画的新高度。动作场面的流畅度、场景的细节丰富度、人物表情的细腻程度，都体现了制作团队五年来的技术积累和艺术追求。</p>
    `,
    tags: ['动画', '科幻', '国产', '末日'],
    related: [1, 12, 6],
  },
  {
    id: 5,
    title: '长津湖之水门桥：铭记历史的壮烈诗篇',
    category: 'movie',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20war%20film%20review%20with%20soldiers%20in%20winter%20battlefield%20snow%20mountains%20heroic%20composition%20dramatic%20cinematic%20lighting%20film%20critique%20banner%20style&width=1200&height=600&seq=article-5&orientation=landscape',
    author: '历史评论员刘洋',
    date: '2026-06-28',
    views: '4200万',
    rating: 9.3,
    duration: '149分钟',
    isVip: false,
    summary: '《长津湖之水门桥》以震撼的战争场面和深刻的人物刻画，再现了抗美援朝战争中最为惨烈的水门桥战役。',
    content: `
      <h2>历史背景</h2>
      <p>水门桥战役是抗美援朝战争长津湖战役的重要组成部分。1950年12月，中国人民志愿军在极寒条件下，三次炸毁水门桥以阻止美军撤退，展现了志愿军战士的钢铁意志。</p>
      <h2>影片特色</h2>
      <p>影片采用IMAX摄影机拍摄，战争场面极具冲击力。导演在保持历史真实性的同时，通过细腻的人物塑造，让观众真切感受到战争的残酷和战士们的无畏精神。</p>
      <h2>演员表现</h2>
      <p>主演们的表演可圈可点，在零下30度的实景拍摄中，他们将志愿军战士在极端环境下的坚韧与牺牲精神展现得淋漓尽致。</p>
    `,
    tags: ['战争', '历史', '抗美援朝', '爱国'],
    related: [1, 6, 2],
  },
  {
    id: 6,
    title: '流浪地球3：中国科幻的宇宙雄心',
    category: 'movie',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20Chinese%20science%20fiction%20film%20review%20with%20Earth%20moving%20through%20space%20powered%20by%20massive%20engines%20Jupiter%20in%20background%20epic%20scale%20cinematic%20banner%20style&width=1200&height=600&seq=article-6&orientation=landscape',
    author: '科幻评论员赵云',
    date: '2026-07-20',
    views: '6800万',
    rating: 9.0,
    duration: '173分钟',
    isVip: true,
    summary: '《流浪地球3》以更为宏大的宇宙视角和深刻的哲学思辨，将中国科幻电影推向了新的高度，成为全球科幻影迷关注的焦点。',
    content: `
      <h2>系列演进</h2>
      <p>从第一部的地球发动机启动，到第二部的月球危机，再到第三部的太阳系边缘探索，《流浪地球》系列一直在不断拓展中国科幻的叙事边界。</p>
      <h2>第三部看点</h2>
      <p>本作中地球已抵达太阳系边缘，人类面临着全新的宇宙威胁。影片在视觉特效上再次升级，宇宙尺度的场景令人叹为观止。同时，故事深入探讨了人类文明在宇宙中的位置和意义。</p>
      <h2>文化意义</h2>
      <p>《流浪地球》系列展现了中国人独特的科幻想象——带着家园去流浪。这种对故土的情感依恋，与西方科幻中的星际殖民形成了鲜明的文化对比，体现了中国科幻的独特魅力。</p>
    `,
    tags: ['科幻', '太空', '中国科幻', '宇宙'],
    related: [1, 5, 4],
  },
];

export function getArticleById(id: number) {
  return articles.find((a) => a.id === id) || null;
}

export const reviews = [
  { name: '张先生', role: '年度会员', content: '用了爱液视频两年多了，内容丰富更新快，画质也很清晰，会员价格也很合理，非常推荐！', rating: 5 },
  { name: '李女士', role: '季度会员', content: '之前一直找不到正版高清的视频平台，朋友推荐了爱液视频后就一直用到现在，体验真的很棒。', rating: 5 },
  { name: '王同学', role: '月度会员', content: '学生党也能接受的会员价格，而且内容真的很全，追剧看综艺都很方便，离线下载功能太实用了。', rating: 4 },
  { name: '赵先生', role: '年度会员', content: '作为影视爱好者，爱液视频的正版授权让我看得放心，4K画质的观影体验也非常震撼。', rating: 5 },
];